import { render, staticRenderFns } from "./WashcareSymbolDialogue.vue?vue&type=template&id=653adacf&"
import script from "./WashcareSymbolDialogue.vue?vue&type=script&lang=ts&"
export * from "./WashcareSymbolDialogue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports